import { Collapse, Alert } from "@mui/material";
import React from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";

import { adModeTable, masterCodeTypes } from "../../../variables/app";
import { convertArrayToSelectOptions } from "../../../templateHelpers";
import TablePickerFromSalesarea from "../../../components/TablePickerFromSalesarea";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import GridLegacy from "@mui/material/GridLegacy";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import { useController, useWatch } from "react-hook-form";
import FormTextTC from "../../../components/Forms/FormTextTC";
import FormFieldTwoColumns from "../../../components/Forms/Layouts/FormFieldTwoColumns";

function Algemeen() {
  const masterCodeTypesOptions = convertArrayToSelectOptions(masterCodeTypes);
  const tableAdModes = convertArrayToSelectOptions(adModeTable);

  const tafelId = useWatch({ name: "id" });
  const masterCode = useWatch({ name: "masterCode" });
  const masterCodeType = useWatch({ name: "masterCodeType" });
  const {
    field: { value: childTablesValue, onChange: childTablesOnChange },
  } = useController({ name: "child_tables" });

  const roomserviceSettingOptions = convertArrayToSelectOptions([
    { value: 0, label: "Follow salesarea setting (default)", transKey: "table.form.roomservice_setting.follow" },
    {
      value: 1,
      label: "Do not use roomservice-mode for this table",
      transKey: "table.form.roomservice_setting.disable",
    },
  ]);

  const getMastercodeInfo = (masterCodeType) => {
    switch (masterCodeType) {
      case 101:
      case 102:
      case 103:
      case 107:
      case 109:
      case 114:
      case 120:
      case 122:
      case 134:
      case 149:
        // Not a translation as discussed because we don't want the terms Adres, Plaats and Postcode to be automatically
        // translated
        return (
          <Alert severity={"info"}>
            This mastercode will add the customfields <b>Adres</b>, <b>Plaats</b> & <b>Postcode</b> to the application.
            Regardless of whether they have been defined or not.
          </Alert>
        );
    }

    return "";
  };

  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <GridLegacy container spacing={1}>
            <GridLegacy alignContent={"flex-start"} container item lg={12} xs={12}>
              <FormSwitchTC name={"testMode"} tDefault={"test mode"} tKey={"tafels.form.algemeen.label.testMode"} />
              <FormSwitchTC
                name={"is_actief"}
                tDefault={"Table active"}
                tKey={"tafels.form.algemeen.label.is_actief"}
              />
              <FormSwitchTC
                name={"untillTableRoulation"}
                tDefault={"Tafel roulatie"}
                tKey={"tafels.form.algemeen.label.untillTableRoulation"}
              />
              <FormSwitchTC
                name={"masterCode"}
                tDefault={"Master code"}
                tKey={"tafels.form.algemeen.label.masterCode"}
              />
            </GridLegacy>
            <Collapse in={!!masterCode}>
              <GridLegacy alignContent={"flex-start"} container item lg={12} xs={12}>
                <div style={{ paddingLeft: "25px", width: "100%" }}>
                  {getMastercodeInfo(masterCodeType)}
                  <FormSelectTC
                    name={"masterCodeType"}
                    options={masterCodeTypesOptions}
                    tDefault={"Mastercode type"}
                    tKey={"tafels.form.algemeen.label.masterCodeType"}
                  />
                </div>
              </GridLegacy>
            </Collapse>
            <GridLegacy alignContent={"flex-start"} container item lg={12} xs={12}>
              <FormSwitchTC
                defaultValue={false}
                name={"custom_data.mastercode_forwarding"}
                tDefault={"Mastercode forwarding"}
                tKey={"tafels.form.algemeen.mastercode_forwarding"}
              />
              <FormSelectTC
                name={"adMode"}
                options={tableAdModes}
                tDefault={"AD Table mode"}
                tKey={"tafels.form.algemeen.label.adTableMode"}
              />
              <FormTextTC name={"naam"} tDefault={"Naam"} tKey={"tafels.form.algemeen.label.naam"} />
              <FormTextTC name={"passcode"} tDefault={"Password"} tKey={"tafels.form.algemeen.label.passcode"} />
              <FormTextTC name={"sector"} tDefault={"sector"} tKey={"tafels.form.algemeen.label.sector"} />
              <FormTextTC
                name={"nameascomment"}
                tDefault={"Name as comment"}
                tKey={"tafels.form.algemeen.label.nameascomment"}
              />

              <FormTextTC
                name={"untillTable"}
                permissionKey={"tafels.fields.untillTable"}
                tDefault={"Untill #ID"}
                tKey={"tafels.form.algemeen.label.untillTable"}
              />

              <FormTextTC
                name={"borkTable"}
                permissionKey={"tafels.fields.borkTable"}
                tDefault={"Bork #ID"}
                tKey={"tafels.form.algemeen.label.borkTable"}
              />

              <FormTextTC
                name={"mrwTable"}
                permissionKey={"tafels.fields.mrwTable"}
                tDefault={"Mr. Winston #ID"}
                tKey={"tafels.form.algemeen.label.mrwTable"}
              />

              <FormTextTC
                name={"lightspeedTable"}
                permissionKey={"tafels.fields.lightspeedTable"}
                tDefault={"Lightspeed #ID"}
                tKey={"tafels.form.algemeen.label.lightspeedTable"}
              />

              <FormTextTC
                name={"vectronTable"}
                permissionKey={"tafels.fields.vectronTable"}
                tDefault={"Vectron #ID"}
                tKey={"tafels.form.algemeen.label.vectronTable"}
              />

              <FormTextTC
                name={"mplusTable"}
                permissionKey={"tafels.fields.mplusTable"}
                tDefault={"Mplus #ID"}
                tKey={"tafels.form.algemeen.label.mplusTable"}
              />

              <FormTextTC
                name={"apiId1"}
                permissionKey={"tafels.fields.apiId1"}
                tDefault={"Api ID 1"}
                tKey={"tafels.form.algemeen.label.apiId1"}
              />
              <FormTextTC
                name={"apiId2"}
                permissionKey={"tafels.fields.apiId2"}
                tDefault={"Api ID 2"}
                tKey={"tafels.form.algemeen.label.apiId2"}
              />
              <FormTextTC
                name={"apiId3"}
                permissionKey={"tafels.fields.apiId3"}
                tDefault={"Api ID 3"}
                tKey={"tafels.form.algemeen.label.apiId3"}
              />
              <FormTextTC
                name={"vid1"}
                permissionKey={"tafels.fields.vid1"}
                tDefault={"Area ID 1"}
                tKey={"tafels.form.algemeen.label.vid1"}
              />
              <FormTextTC
                name={"vid2"}
                permissionKey={"tafels.fields.vid2"}
                tDefault={"Area ID 2"}
                tKey={"tafels.form.algemeen.label.vid2"}
              />
              <FormTextTC
                name={"vid3"}
                permissionKey={"tafels.fields.vid3"}
                tDefault={"Area ID 3"}
                tKey={"tafels.form.algemeen.label.vid3"}
              />
              <FormSwitchTC
                name={"payDirect"}
                tDefault={"Betaal direct"}
                tKey={"tafels.form.algemeen.label.payDirect"}
              />
              <FormTextTC
                name={"usePayTable"}
                tDefault={"Betaal tafel"}
                tKey={"tafels.form.algemeen.label.usePayTable"}
              />
              <FormSwitchTC name={"ayce"} tDefault={"All you can eat"} tKey={"tafels.form.algemeen.label.ayce"} />
              <FormTextTC
                fieldProps={{ disabled: true }}
                name={"qr_code__code"}
                tDefault={"QR Code"}
                tKey={"tafels.form.algemeen.label.code"}
              />
              <FormTextTC
                fieldProps={{ disabled: true }}
                name={"qr_code__mid"}
                tDefault={"WEB-Code"}
                tKey={"tafels.form.algemeen.label.mid"}
              />
              <FormTextTC
                fieldProps={{ disabled: true }}
                name={"open_ticket.pincode"}
                tDefault={"Random generated PIN"}
                tKey={"open_ticket.pincode"}
              />
              <FormTextTC
                name={"qr_code__redirect_url"}
                tDefault={"Redirect url"}
                tKey={"tafels.form.algemeen.label.redirect_url"}
              />

              <FormSelectTC
                defaultValue={0}
                name={"custom_data.roomservice_setting"}
                options={roomserviceSettingOptions}
                tDefault={"Roomservice"}
                tKey={"tafels.form.algemeen.roomservice_select"}
              />

              <FormFieldTwoColumns tDefault={"Tables"} tKey={"tafels.tables"}>
                <TablePickerFromSalesarea
                  defaultValue={childTablesValue}
                  handleValue={(value) => {
                    childTablesOnChange(value);
                  }}
                  key={tafelId}
                  selectedItems={childTablesValue}
                />
              </FormFieldTwoColumns>
            </GridLegacy>
          </GridLegacy>
        </CardBody>
      </Card>
    </div>
  );
}

export default Algemeen;
